import { apiJson } from '../api';
import type { ApiKey } from '../types';

export async function listApiKeys(): Promise<ApiKey[]> {
  return apiJson<ApiKey[]>('/api/admin/api-keys');
}

export async function createApiKey(name?: string): Promise<ApiKey> {
  return apiJson<ApiKey>('/api/admin/api-keys', {
    method: 'POST',
    json: { name: name || null },
  });
}

export async function revokeApiKey(keyId: string): Promise<void> {
  return apiJson<void>(`/api/admin/api-keys/${keyId}`, { method: 'DELETE' });
}
